import { render, staticRenderFns } from "./DetailsDiscount.vue?vue&type=template&id=90b74d04"
import script from "./DetailsDiscount.vue?vue&type=script&lang=js"
export * from "./DetailsDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports